import { Tag } from 'antd'
import React from 'react'
import PnlPrice from '../../PositionColumns/PnlPrice'
import WalletTag from '../../WalletTag'
import Column_walletlist_action from './column_walletlist_action'
import { TagWrap } from './styles'

export const column_walletlist = mutate => {
	return [
		{
			title: '내부계좌',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			render: (text, record) => (
				<WalletTag walletid={record?.id} type={record?.wallet_type} />
			),
		},
		{
			title: '화폐',
			dataIndex: 'wallet_type',
			key: 'wallet_type',
			align: 'center',
			render: (text, record) => (
				<TagWrap>
					<Tag>{record?.wallet_symbol}</Tag>
				</TagWrap>
			),
		},
		{
			title: '잔액',
			dataIndex: 'balance',
			align: 'center',
			key: 'balance',
			render: (text, record) => (
				<>
					{record?.wallet_type == 9 ? (
						<PnlPrice
							price={text}
							dp={0}
							krw={true}
							style={{ color: 'black' }}
							plus={false}
						/>
					) : (
						<PnlPrice
							price={text}
							dp={record?.wallet_type == 9 ? 0 : undefined}
							usdt={true}
							style={{ color: '#555' }}
							plus={false}
						/>
					)}
				</>
			),
		},
		{
			title: '동결금',
			dataIndex: 'lockbalance',
			align: 'center',
			key: 'lockbalance',
			render: (text, record) => (
				<>
					{record?.wallet_type == 9 ? (
						<PnlPrice
							price={text}
							dp={0}
							krw={true}
							style={{ color: 'black' }}
							plus={false}
						/>
					) : (
						<PnlPrice
							price={text}
							dp={record?.wallet_type == 9 ? 0 : undefined}
							usdt={true}
							style={{ color: '#555' }}
							plus={false}
						/>
					)}
				</>
			),
		},
		{
			title: '관리',
			dataIndex: 'action',
			align: 'center',
			key: 'action',
			render: (text, record) => (
				<Column_walletlist_action record={record} mutate={mutate} />
			),
		},
	]
}
